import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import IoIosArrowForward from "../../assets/icons/arrowRight";
import * as Path from "../../routes/routesPath";
import { getMyAccountPagePath, getUserImage } from "../../utils/helpers";
import useAuth from "../../hooks/useAuth";
import { isArray } from "../../utils/formatersAndParsers";
import { handleApiRequest } from "../../services/handleApiRequest";
import { logout } from "../../redux/auth/slice";
import { logoutUser } from "../../redux/auth/thunk";
import DeletePopup from "../../Component/Modals/deletePop";
import SharePop from "../../Component/Modals/sharePop";

export const userCenter = [
  { label: "My Account", path: getMyAccountPagePath() },
  {
    label: "Saved Stories",
    path: getMyAccountPagePath(Path.privateRoutes.bookmarkedStoriesRoute),
  },
  {
    label: "Private Directory",
    path: getMyAccountPagePath(Path.privateRoutes.privateDirectoryRoute),
  },
  {
    label: "Feedback and Queries",
    path: getMyAccountPagePath(Path.privateRoutes.myQueriesRoute),
  },
  // { value: "replies", label: "Comments and Replies", path: "" },
];

export default function MyAccountSideOptions({ wrapperClassName = "", handleClose = () => {} }) {
  const { isAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { userProfile = {} } = useSelector((state) => state.auth || {});
  const { contentPagesList } = useSelector((state) => state.common || {});
  const [userAction, setUserAction] = useState(null);

  const handleLogout = async () => {
    navigate(Path.homeRoute, { replace: true });
    dispatch(logout());
    await handleApiRequest(logoutUser, {}, false);
    setUserAction({});
  };

  return (
    <>
      <div className={`profileOptions ${wrapperClassName}`}>
        {isAuthenticated && (
          <div className="text-center px-2">
            <img
              className="img-large img-fluid object-fit-cover rounded-circle mt-3 mb-1"
              src={getUserImage(userProfile)}
              alt={!userProfile ? "userImage" : userProfile?.name}
              onError={(e) => {
                e.target.src = getUserImage();
              }}
            />
            <p className="truncate-1  m-0">{userProfile?.name}</p>
            <p className="lh-12 truncate-1 muted small m-0">{userProfile?.email}</p>
          </div>
        )}
        <div className="profileItemsList mt-3">
          {isAuthenticated && (
            <div className="mx-2 px-2">
              {userCenter.map((option, i) => (
                <NavLink
                  key={option.path}
                  to={option.path}
                  className={`profileItem mb-0 pt-2 pb-1 d-flex align-items-center justify-content-between border-bottom text-decoration-none text-color ${
                    pathname.includes(option.path) ? "profileItemActive" : ""
                  }`}>
                  <p
                    className="align-items-center d-flex justify-content-between mb-0 w-100"
                    onClick={handleClose}>
                    {option.label}
                    <IoIosArrowForward />
                  </p>
                </NavLink>
              ))}
              <p
                className={`profileItem mb-0 pt-2 pb-1 d-flex align-items-center justify-content-between border-bottom`}
                onClick={() => {
                  handleClose();
                  setTimeout(() => {
                    setUserAction({ action: "showSharePop" });
                  }, 0);
                }}>
                Invite Friends
                <IoIosArrowForward />
              </p>
            </div>
          )}
          <div className="mx-2 my-3">
            <div className="w-fit mb-2 ms-1 border-danger border-bottom">
              <b className="mb-1">FeelingHub</b>
              <p className="w-50 border-top border-danger mb-1" />
            </div>
            <div className="px-2">
              <NavLink
                to={Path.contactUsRoute}
                className={`profileItem mb-0 pt-2 pb-1 d-flex align-items-center justify-content-between border-bottom text-decoration-none text-color ${
                  pathname.includes(Path.contactUsRoute) ? "profileItemActive" : ""
                }`}>
                <p
                  className="align-items-center d-flex justify-content-between mb-0 w-100"
                  onClick={handleClose}>
                  Contact Us
                  <IoIosArrowForward />
                </p>
              </NavLink>
              {isArray(contentPagesList).map((page) => (
                <NavLink
                  key={page._id}
                  to={`/${page.slug}`}
                  className={`profileItem mb-0 pt-2 pb-1 d-flex align-items-center justify-content-between border-bottom text-decoration-none text-color ${
                    pathname.includes(page.path) ? "profileItemActive" : ""
                  }`}>
                  <p
                    className="align-items-center d-flex justify-content-between mb-0 w-100"
                    onClick={handleClose}>
                    {page.title}
                    <IoIosArrowForward />
                  </p>
                </NavLink>
              ))}
            </div>
          </div>
          {isAuthenticated && (
            <div className="px-2">
              <p
                className="mx-2 mb-3 mt-4 pb-1 d-flex align-items-center justify-content-between border-bottom border-danger"
                onClick={() => {
                  handleClose();
                  setTimeout(() => {
                    setUserAction({ action: "logout" });
                  }, 0);
                }}>
                <span>Logout</span>
                <span>
                  <IoIosArrowForward />
                </span>
              </p>
            </div>
          )}
        </div>
      </div>

      {userAction?.action === "showSharePop" && (
        <SharePop userAction={userAction} setUserAction={setUserAction} />
      )}

      {userAction?.action === "logout" && (
        <DeletePopup
          userAction={userAction}
          setUserAction={setUserAction}
          onSubmit={handleLogout}
          submitLabel={"Logout"}
        />
      )}
    </>
  );
}
